import React, { useState, useEffect, useContext } from "react";
import "../ContentPages/style.css";
import SubmitButton from "../Buttons/SubmitButton";
import BackButton from "../Buttons/BackButton";
import { useForm } from "react-hook-form";
import { AppContext } from "../../contexts/AppContext";
import {
  getCountryNameById,
  getLabelFromId,
} from "../../Services/localStorage.tsx";
import { useNavigate } from "react-router-dom";
import GenderChange from "../GenderChange/index.js";
import NameChange from "../NameChange/index.js";
import FieldError from "../FieldError/index.jsx";

const ReviewImmigration = ({ handleNext, handleBack }) => {
  const { handleSubmit } = useForm();

  const { appState, userFlows } = useContext(AppContext);
  const navigate = useNavigate();

  const immigrationData = appState.requestPayload.applicant;
  const eventData = appState.requestPayload.eventTypeSearch[0] || {};
  const supportingInformation = appState.requestPayload.supportingInformation;

  const [genderLabel, setGenderLabel] = useState("");
  const [addressCountryLabel, setAddressCountryLabel] = useState("");
  const [issuingCountryLabel, setIssuingCountryLabel] = useState("");

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    try {
      const options = { day: "numeric", month: "long", year: "numeric" };
      return new Date(dateStr).toLocaleDateString("en-NZ", options); // 27 April 1948
    } catch {
      return dateStr;
    }
  };

  useEffect(() => {
    // Load passport data from localStorage if not already in state

    getLabelFromId("GenderReference", eventData?.genderId).then(
      (genderLabel) => {
        setGenderLabel(genderLabel);
      }
    );

    getCountryNameById(immigrationData.countryOfBirthId).then((countryName) => {
      setAddressCountryLabel(countryName);
    });
    getCountryNameById(eventData.countryOfEventId).then((countryName) => {
      setIssuingCountryLabel(countryName);
    });
  }, [eventData?.genderId, immigrationData?.countryOfBirthId]);

  const onSubmit = () => {
    if (userFlows.showPartnerStore) {
      navigate("/app/photo-id");
      return;
    }
    if (!userFlows.showLiveness) {
      navigate("/app/photo-id");
      return;
    }
    handleNext();
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="intro">
          <h1 className="intro-title-mi" lang="mi-NZ">
            Arotakehia ō taipitopito
          </h1>
          <hr />
          <h1 className="intro-title">Review your details</h1>
          <div style={{ marginTop: 64 }}>
            <FieldError
              info={
                "Please check this information is correct. This is the information we'll use to verify your identity."
              }
              error={null}
            />

            {appState?.requestPayload?.supportingInformation
              ?.nameChangeSourceCode && <NameChange />}
            {appState?.requestPayload?.supportingInformation
              ?.genderSourceCode && <GenderChange />}
          </div>

          <div className="step-container">
            <h2 className="step-title mb-2">Your immigration details</h2>
            <div className="step-container-nospace">
              <div className="step-container-box">
                <p className="label">Given name(s)</p>
                <p className="value">
                  {immigrationData?.namesKnownAs?.[0]?.givenNames || "-"}
                </p>
              </div>
              <div className="step-container-box">
                <p className="label">Surname or family name</p>
                <p className="value">
                  {immigrationData?.namesKnownAs?.[0]?.familyName || "-"}
                </p>
              </div>
              <div className="step-container-box">
                <p className="label">Date of birth</p>
                <p className="value">
                  {formatDate(immigrationData?.dateOfBirth) || "-"}
                </p>
              </div>
              <div className="step-container-box">
                <p className="label">Place of birth (town/city)</p>
                <p className="value">
                  {immigrationData?.placeOfBirth?.trim()
                    ? immigrationData.placeOfBirth
                    : "Unknown"}
                  </p>
              </div>
              <div className="step-container-box">
                <p className="label">Country of birth</p>
                <p className="value">{addressCountryLabel}</p>
              </div>
              {eventData?.documentNumber && (
                <div className="step-container-box">
                  <p className="label">Current Passport number</p>
                  <p className="value">
                    {eventData?.documentNumber || "-"}
                  </p>{" "}
                  {/* If you store passport number here */}
                </div>
              )}

              {eventData?.countryOfEventId && (
                <div className="step-container-box">
                  <p className="label">Issuing Country</p>
                  <p className="value">{issuingCountryLabel}</p>
                </div>
              )}
              {supportingInformation?.inzVisaNumber && (
                <div className="step-container-box">
                  <p className="label">NZ Immigration Visa number</p>
                  <p className="value">
                    {supportingInformation?.inzVisaNumber}
                  </p>
                </div>
              )}
              <div className="step-container-box">
                <p className="label">Gender</p>
                <p className="value">{genderLabel}</p>
              </div>
              {/* Add more fields if available in your localStorage data */}
            </div>
          </div>
        </div>

        <div className="step-button-container">
          <SubmitButton text={"Confirm"} type="submit" />
          <BackButton text={"Back"} onClick={handleBack} />
        </div>
      </form>
    </>
  );
};

export default ReviewImmigration;
